import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_MANDANT_OPTIONS = '[VeranstaltungenModul] GetFunkprotokollMandantOptions laden';
export const GET_FUNKPROTOKOLL_MANDANT_OPTIONS_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollMandantOptions ausführen';
export const GET_FUNKPROTOKOLL_MANDANT_OPTIONS_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollMandantOptions laden erfolgreich';
export const GET_FUNKPROTOKOLL_MANDANT_OPTIONS_FEHLER = '[VeranstaltungenModul] GetFunkprotokollMandantOptions Ladefehler';
export const GET_FUNKPROTOKOLL_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollMandantOptions nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollMandantOptionsAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_MANDANT_OPTIONS;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollMandantOptionsAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollMandantOptionsErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class GetFunkprotokollMandantOptionsFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunkprotokollMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollMandantOptionsActions =
    GetFunkprotokollMandantOptionsAction
    | GetFunkprotokollMandantOptionsAusfuehrenAction
    | GetFunkprotokollMandantOptionsErfolgreichAction
    | GetFunkprotokollMandantOptionsFehlerAction
    | GetFunkprotokollMandantOptionsNichtAusgefuehrtAction
    ;
